export default __webpack_public_path__ + "static/media/the_opportunity_l.c19dc121.jpg";